import {
  confirmUser,
  ConfirmUserPayload,
  ConfirmUserResponse,
} from 'app/api/confirmUser'
import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import { useMutation, UseMutationResult, useQueryClient } from 'react-query'

export const useConfirmUser = (): UseMutationResult<
  ConfirmUserResponse,
  AxiosError<ApiError>,
  ConfirmUserPayload
> => {
  {
    const queryClient = useQueryClient()
    return useMutation(confirmUser, {
      onSuccess: () => {
        queryClient.invalidateQueries('user')
      },
    })
  }
}
